import {calculateIntersection, getLineEquation, getPerpOffset} from '../../../../../../helpers/coordinatesHelper';

function getOffsetSide(points, offsets) {
  const side = [getPerpOffset(points[0], points[1], offsets[0], 1)];
  for (let index = 1; index < points.length - 1; index++) {
    const previous = points[index - 1];
    const current = points[index];
    const next = points[index + 1];
    const previousOffset = offsets[index - 1];
    const nextOffset = offsets[index];
    const previousEnd = getPerpOffset(current, previous, previousOffset, -1);
    const nextStart = getPerpOffset(current, next, nextOffset, 1);
    const intersection = calculateIntersection(
      getLineEquation(getPerpOffset(previous, current, previousOffset, 1), previousEnd),
      getLineEquation(nextStart, getPerpOffset(next, current, nextOffset, -1))
    );
    side.push(intersection || previousEnd);
  }
  side.push(getPerpOffset(points[points.length - 1], points[points.length - 2], offsets[offsets.length - 1], -1));
  return side;
}

// Match creation's polygon simplification without changing the order of surviving corners.
export function getFreeFormAngleOutline(points, thickness) {
  const offsets = Array.isArray(thickness) ? thickness.map(width => width / 2) : points.slice(1).map(() => thickness / 2);
  const outline = [
    ...getOffsetSide(points, offsets),
    ...getOffsetSide([...points].reverse(), [...offsets].reverse())
  ];
  let removedCorner = true;
  while (removedCorner && outline.length > 3) {
    removedCorner = false;
    for (let index = 0; index < outline.length; index++) {
      const previous = outline[(index + outline.length - 1) % outline.length];
      const current = outline[index];
      const next = outline[(index + 1) % outline.length];
      const length = Math.hypot(next.x - previous.x, next.y - previous.y);
      const cross = (current.x - previous.x) * (next.y - previous.y)
        - (current.y - previous.y) * (next.x - previous.x);
      const between = (current.x - previous.x) * (current.x - next.x)
        + (current.y - previous.y) * (current.y - next.y) <= 0.000001;
      if (Math.hypot(current.x - previous.x, current.y - previous.y) < 0.000001
        || (length > 0 && Math.abs(cross) / length < 0.000001 && between)) {
        outline.splice(index, 1);
        removedCorner = true;
        break;
      }
    }
  }
  return outline;
}
